import React from 'react';
import HowItWorks from '../components/HowItWorks';
import BookingSystem from '../components/BookingSystem';
import Advantages from '../components/Advantages';
import MostBooked from '../components/MostBooked';
import Fleet from '../components/Fleet';
import Hero from '../components/Hero';
import { TrustRow, OurServices, WhyChoose, GoogleReviews, FAQ } from '../components/SharedSections';
import { translations } from '../mockData';
import { rentalsFaq as rentalsFAQ } from '../data/faq';


const RentalsPage = ({ language }) => {
  const t = translations[language];
  const isRo = language === 'ro';
  const [selectedCar, setSelectedCar] = React.useState(null);

  const handleBookCar = (car) => {
    setSelectedCar(car);
    setTimeout(() => {
      const el = document.getElementById('booking');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      <Hero t={t} language={language} backgroundImage="/images/rentals-hero.webp" />
      <TrustRow isRo={isRo} />
      <MostBooked t={t} onBookCar={handleBookCar} language={language} />
      <HowItWorks language={language} />
      <BookingSystem t={t} preselectedCar={selectedCar} language={language} />
      <Advantages t={t} language={language} />
      <Fleet t={t} onBookCar={handleBookCar} language={language} />
      <WhyChoose isRo={isRo} />
      <OurServices isRo={isRo} />
      <GoogleReviews isRo={isRo} />
      <FAQ isRo={isRo} items={rentalsFAQ} />
    </>
  );
};

export default RentalsPage;
